export type ContextSourceType = 'Document' | 'SourceCode' | 'Image' | 'Archive'

export type ContextSourceKind = 'File' | 'Repository' | 'Wiki'

export interface ContextSourceListItem {
  id: string
  name: string
  description: string | null
  sourceType: ContextSourceType
  kind: ContextSourceKind
  sizeBytes: number | null
  connectorType: string | null
  connectorId: string | null
  createdAt: string
  uploadedByName: string | null
  uploadedByEmail: string | null
  sourceUrl: string | null
}

export interface ContextRepositoryUploadItem {
  connectorType: string
  connectorId: string
  repositoryId: string
  repositoryFullName: string
  repositoryUrl?: string | null
  description?: string | null
}

export interface UploadContextRepositoriesRequest {
  repositories: ContextRepositoryUploadItem[]
}

export interface UploadContextRepositoriesResponse {
  contextSourceIds: string[]
  skippedCount: number
}

export interface ContextSourceFilters {
  search?: string
  sourceType?: string
  kind?: string
  connectorType?: string
  connectorId?: string
  createdByCurrentUser?: boolean
  sortBy?: ContextSourceSortColumn
  sortDirection?: 'asc' | 'desc'
}

export type ContextSourceSortColumn = 'name' | 'sourceType' | 'uploadedBy' | 'createdAt'

export const CONTEXT_SOURCE_DEFAULT_SORT_DIRECTIONS: Record<ContextSourceSortColumn, 'asc' | 'desc'> = {
  name: 'asc',
  sourceType: 'asc',
  uploadedBy: 'asc',
  createdAt: 'desc',
}

export interface ContextWikiPageUploadItem {
  connectorId: string
  azureDevOpsProject: string
  wikiId: string
  wikiName: string
  pagePath: string
  pageUrl?: string | null
  includeSubPages: boolean
  description?: string | null
}

export interface UploadContextWikiPagesRequest {
  pages: ContextWikiPageUploadItem[]
}

export interface UploadContextWikiPagesResponse {
  contextSourceIds: string[]
  skippedCount: number
}
